module.exports = __webpack_public_path__ + "img/ford-commercial-vehicle-display.5d4e898e.png";